import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import { PeriodMode } from '../../../../../../../../enums/periodMode'
import { useImportedInvoicesListFilters } from '../../../../context/importedInvoicesListFilters'

export const ImportedInvoicesTableEmptyRowInfo = (): ReactNode => {
  const { t } = useTranslation()
  const [filters] = useImportedInvoicesListFilters()

  if (filters.searchQuery) {
    return t('imported_invoices.list.no_results.search')
  }

  if (filters.period && filters.period !== PeriodMode.All) {
    return t('imported_invoices.list.no_results.period')
  }

  return t('table.empty_message')
}
